// Runtime API/app URLs, so one production build serves every client domain.
//
// Why this exists: Create React App inlines process.env.REACT_APP_* into the
// bundle at BUILD time, so a build made for jivanmart could only ever talk to
// jivanmart - which is what forced a separate build (and a separate edit of
// .env) per client. Every deployment follows the same shape though:
//
//     app  ->  https://<client-domain>
//     api  ->  https://<client-domain>/api      (IIS reverse-proxies /api to
//                                                the Node server - see the
//                                                web.config in wwwroot/api)
//
// so the browser can work both out for itself from the address it was loaded
// from. The bundle ends up containing no domain at all, which means the same
// build/ folder can be copied to every client's wwwroot, and the only
// per-client difference stays where it already lives: web.config's backend
// address.
//
// The process.env values are kept as an override, purely for local dev, where
// the app (:3000) and the API (:5000) are NOT on the same origin so the
// derivation above wouldn't hold. Those live in .env.development, which CRA
// only loads for `npm start` - `npm run build` doesn't see them, and falls
// through to the runtime values here.
const origin = typeof window !== "undefined" && window.location ? window.location.origin : "";

export const API_BASE = process.env.REACT_APP_API || `${origin}/api`;

export const APP_URL = process.env.REACT_APP_URL || origin;
